import { render } from "./SkeletonList.vue?vue&type=template&id=72c4701f&scoped=true&ts=true"
import script from "./SkeletonList.vue?vue&type=script&lang=ts"
export * from "./SkeletonList.vue?vue&type=script&lang=ts"

import "./SkeletonList.vue?vue&type=style&index=0&id=72c4701f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c4701f"]])

export default __exports__